import { UpdateLegalClientHeadParams } from 'api/types/params';
import { isFinanceProject, isGlobalProject } from 'config';
import {
  parseTaxResidencyParam,
  parsePepConnectionParam,
  parseCitizenshipsParam,
  parseAdditionalInformationFileIdsParam,
  parseAddressWithFilesParam,
} from 'modules/client/common/helpers';
import { parseHeadPositionParam } from 'modules/client/common/helpers/parseParams/parseHeadPositionParam';
import { parseIdentityDocumentWithFilesParam } from 'modules/client/common/helpers/parseParams/parseIdentityDocumentParam';

import { LegalClientHeadFormType } from '../../forms/legalClientHeadForm';

export const getLegalClientHeadSubmitData = (
  versionNumber: number,
  values: LegalClientHeadFormType
): UpdateLegalClientHeadParams => {
  const addressParam = parseAddressWithFilesParam(values);

  const isGlobal = isGlobalProject();
  const isFinance = isFinanceProject();

  return {
    versionNumber,
    reason: values.reasonChange.reason,
    firstName: values.personalData.firstName,
    lastName: values.personalData.lastName,
    middleName: values.personalData.middleName ?? null,
    dateOfBirth: values.personalData.dateOfBirth,
    citizenships: parseCitizenshipsParam(values),

    registrationAddress: isFinance
      ? addressParam.registrationAddress
      : undefined,
    residentialAddress: addressParam.residentialAddress,
    placeOfBirth: isGlobal ? addressParam.placeOfBirth : undefined,

    taxResidences: parseTaxResidencyParam(values),

    pepConnection: values.pepConnection.relation?.value!,
    connectedPepInfo: !isGlobal ? parsePepConnectionParam(values) : undefined,

    additionalInformationFileIds: parseAdditionalInformationFileIdsParam(
      values.additionalDocumentsFiles
    ),

    position: parseHeadPositionParam(values),

    identityDocument: parseIdentityDocumentWithFilesParam(values),
  };
};
